import React from 'react';
import Media from '../';

import './_website.scss';

import devices from './assets/Website-Devices.png';

class Website extends Media {
  renderText() {
    const { item } = this.props;
    return (
      <div className="media-content">
        <div className="description">
          {item.description}
        </div>
      </div>
    );
  }

  renderImages() {
    return (
      <div id="devices">
        <img
          src={devices}
          alt="Frontier Geomatics Inc's website on a phone, tablet, and PC"
        />
      </div>
    );
  }

  renderContent() {
    const { item } = this.props;
    return (
      <section id="website" className="media-item star-bg">
        <div id="title">
          <h2>Websites</h2>
        </div>

        <div id="spacer" />

        <div id="imagery">
          {this.renderImages()}
        </div>

        <div id="media-content">
          <p>{item.description}</p>
        </div>
      </section>

    );
  }
}

export default Website;



// WEBPACK FOOTER //
// ./src/components/media/website/index.js